export const toggleMobileNav = async () => {
    const nav = document.querySelector('.Navigation--mobile') as HTMLElement
    nav.setAttribute('data-level', '0')
    nav.style.marginTop = `${document.querySelector('.Header--mobile')!.clientHeight - 50
        }px`
    nav.classList.toggle('Navigation--open')
    const header = document.querySelector('.Header--mobile')!
    header.classList.toggle('Header--nav-open')
};